module.exports = __webpack_public_path__ + "static/b64ab0d67b49cca99a199cb1117ae11c2ab09a3fc896a4880a29f3f86a8424d8-691f8c17e68da802d1c56507080ad674.png";